import styled from 'styled-components';
import { scrollbar } from 'modules/scrollbar';
import { pxToRem } from 'modules/spacing';
import { themeGet } from 'modules/tetrisTheme';
export const Container = styled.div `
  position: relative;
  max-width: 100%;
  overflow-x: auto;
  box-sizing: border-box;
  height: ${({ $maxHeight }) => $maxHeight && $maxHeight};

  --table-head-cell-height: ${pxToRem(40)};
  --table-loading-transition: 225ms ease-in-out;
  --table-display-head-body-gap: ${(props) => (props.$border ? 'none' : 'table-row')};
  --table-border-radius: ${(props) => (props.$border ? '0' : themeGet('borderRadius.md'))};
  --table-border-color: ${(props) => props.$border ? themeGet('colors.background.100') : themeGet('colors.background.50')};

  border-radius: ${themeGet('borderRadius.md')};
  border: solid ${pxToRem(1)} var(--table-border-color);

  ${scrollbar()};
`;
export const StyledTable = styled.table `
  width: 100%;
  position: relative;
  border-spacing: 0;
  z-index: 0; /* For sticky columns not to overlap on other component with z-index */
  background-color: ${themeGet('colors.background.50')};
  table-layout: ${({ $layout }) => $layout};

  ${(props) => props.$dense
    ? `
      --table-body-cell-height: ${pxToRem(40)};
      --table-cell-padding: ${themeGet('spacing.md')};
      --table-display-head-body-gap-spacing: ${themeGet('spacing.xs')};
    `
    : `
      --table-body-cell-height: ${pxToRem(48)};
      --table-cell-padding: ${themeGet('spacing.lg')};
      --table-display-head-body-gap-spacing: ${themeGet('spacing.sm')};
    `}
`;
